import React from "react";
import "./PersonaChip.css";
import { PersonaLinkRecordOrientation } from "winslow-core";
import { MyTooltip } from "../common/MyTooltip";

interface PersonaChipProps {
  personaName: string;
  orientation: PersonaLinkRecordOrientation;
  onDelete: () => void;
  onToggleOrientation: () => void;
}

export const PersonaChip: React.FC<PersonaChipProps> = ({
  personaName,
  orientation,
  onDelete,
  onToggleOrientation,
}) => {
  return (
    <div className={`persona-chip ${orientation.toLowerCase()}`}>
      <MyTooltip
        title={
          orientation === PersonaLinkRecordOrientation.INCLUSIONARY
            ? "Click to exclude this resource"
            : "Click to include this resource"
        }>
        <div className="persona-chip-arrow" onClick={onToggleOrientation}>
          {orientation === PersonaLinkRecordOrientation.INCLUSIONARY
            ? "↑"
            : "↓"}
        </div>
      </MyTooltip>
      <div className="persona-chip-name">{personaName}</div>
      <div className="persona-chip-delete" onClick={onDelete}>
        ×
      </div>
    </div>
  );
};
